import React from 'react';

import tobeor from 'tobeor';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import Loader from '../../Loader';
import RestoreTrplBtn from './RestoreTrplBtn';

export default ({
  rst,
  trpl,
  setTrpl,
  classes,
  constant,
  isNewNode,
  trplIndex,
  ancestorId,
  loadingTids,
  deletedTids,
  setLoadingTids,
  resetDeletedTrplId,
  disableTrplEditing,
  updateDataOnRestoreTrpl,
}) => {

  const isTimeRst = tobeor(rst.type, ['DATE', 'TIME', 'DATE_AND_TIME']);
  const isInteger = tobeor(rst.type, ['INTEGER', 'FLOAT']);
  const isFile = tobeor(rst.type, ['render_parts', 'FILE', 'IMAGE', 'GEOLOCATION', 'TELEGRAM_LOCATION']);

  const newValue = isTimeRst && trpl.val === '' ? new Date().getTime() : trpl.val;

  const rstDefaultUnitDafault = rst.units && rst.units.find(unit => unit.hasOwnProperty('default'));
  const defaultUnitId = rstDefaultUnitDafault ? rstDefaultUnitDafault.id : '';
  const rstTomezoneDefault = rst.timezones && rst.timezones.find(zone => zone.hasOwnProperty('default'));
  const defaultTimezoneId = rstTomezoneDefault ? rstTomezoneDefault.id : '';
  const addition = isTimeRst ? (trpl && trpl.hasOwnProperty('tz') ? {tz: trpl.tz} : defaultTimezoneId ? {tz: defaultTimezoneId} : null)
    : isInteger ? (trpl && trpl.hasOwnProperty('units') ? {units: trpl.units} : defaultUnitId ? {units: defaultUnitId} : null) : null;

  const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

  const deletedTidObj = !trpl.tid && deletedTids && deletedTids.length && deletedTids.find(deleted => +Object.keys(deleted)[0] === +rstId);
  const deletedTid = deletedTidObj && Object.values(deletedTidObj)[0];

  const CrealeIcon = trplIndex === 0 ? CheckIcon : AddIcon;

  return (
    <div className={classes.setDeleteTrplBtnsContainer}>
      {loadingTids.includes(rstId) || loadingTids.includes(trpl.tid) ? (
        <Loader style={{ zoom: '0.7', marginLeft: '5px' }} />
      ) : (
        <React.Fragment>
          <div className={classes.alignCenter}>
            {!isFile && !constant && !disableTrplEditing ? (
              <CrealeIcon
                style={{
                  display: 'flex',
                }}
                disabled={isNewNode}
                onClick={() => {
                  setTrpl(ancestorId, rst, newValue, rst.type === 'BOOLEAN', trpl && trpl.tid ? trpl.tid : undefined, setLoadingTids, addition);
                }}
                className={`${classes.rstIconBtn} ${classes.rstIconBtnGreen}`}
              />
            ) : null}
            
            {deletedTid && !isFile ? (
              <RestoreTrplBtn
                rstId={rstId}
                classes={classes}
                ancestorId={ancestorId}
                deletedTid={deletedTid}
                setLoadingTids={setLoadingTids}
                resetDeletedTrplId={resetDeletedTrplId}
                updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              />
            ) : null}
          </div>
        </React.Fragment>
        )
      }
    </div>
  );
};
